export class HttpError extends Error {
  public readonly status: number | null;
  public readonly additionalData: any | null;
  constructor(
    message?: string,
    options?: { status: number; additionalData: string }
  ) {
    super(message);
    Object.setPrototypeOf(this, HttpError.prototype);
    this.status = options.status || null;
    this.additionalData = options.additionalData || null;
    if (!message && this.status) {
      this.message = `server responded with ${this.status} status code`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/http-error.ts